import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails13 = () => {
  const fertilizerData = {
    title: "Utpann Organic Manure",
    category: "Fermented Organic Manure (FOM)",
    image: "/assets/Product/img13.png", // Aap apne path ke hisaab se change kar sakte hain
    description:
      "Is produced through a controlled biogas fermentation process using organic waste. It acts as a natural carbon enhancer, improving soil structure, boosting microbial activity, and increasing organic carbon content. A safe and consistent alternative to traditional cow dung, it supports sustainable farming and long-term soil health.",
    price: "450",
    priceNote: "Per 30 kg Bag (Gujarat)",
    recommendations: ["All Crops", "Soil Carbon Enhancement", "Forestry"],
    specsTitle: "FCO-1985 Technical Specifications",
    specs: [
      { label: "Moisture% by weight maximum", value: "30-70%" },
      {
        label: "Particle Size",
        value: "Minimum 90% Material Should Pass through 4.0mm IS sieve",
      },
      { label: "Total Organic Carbon minimum", value: "12-14%" },
      { label: "pH", value: "6.0-8.4" },
      { label: "Electrical Conductivity", value: "Not more than 4.0" },
      { label: "Pathogens", value: "Nil" },
    ],
    packaging: [
      { label: "Bulk Bags", value: "1000kg FIBC" },
      { label: "Standard Bags", value: "30kg" },
      { label: "Containers", value: "20ft & 40ft available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Carbon Enhancer - Builds soil organic carbon and long-term fertility",
      "Better Soil Structure - Improves aeration and water-holding capacity",
      "Microbial Boost - Activates beneficial soil microbes",
      "Balanced Nutrition - Slow-release nutrients for steady crop growth",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={fertilizerData} />

        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails13;
